/**
 * @author salla.sai shiva
 * @Date: 2022-11-04 16:20:30
 * @Last Modified by: salla.sai shiva
 * @Last Modified time: 2022-11-04 16:50:30
*/

import { constants } from '../../../devUtils';
import { PDF_IMPORTS } from '../../../devUtils/assests';

const COLLAPSE_MCMD = Object.freeze({

  DS_DETAILS: [
    // {
    //   dsId: 0,
    //   dsTitle: '(A) Details of Business',
    //   dsDataSlug: [
    //     {
    //       id: 0,
    //       title: 'Business Overview',
    //       link: constants.LINK_ZAGGLE_OVERVIEW,
    //     },
    //   ],
    // },
    {
      dsId: 1,
      dsTitle: '(B) Terms and Conditions of appointment of Independent Directors',
      dsDataSlug: [
        {
          id: 0,
          title: 'Terms and Conditions of appointment of Independent Directors',
          link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/disclosures-regulation/terms-and-conditions-of-appointment-of-independent-directors.pdf',
        },
      ],
    },
    {
      dsId: 2,
      dsTitle: '(C) Composition of various Committees of Board of Directors',
      dsDataSlug: [
        {
          id: 0,
          title: 'Audit Committee',
          link: constants.AUDIT_COMMITTEE,
        },
        {
          id: 1,
          title: 'Nomination & Remuneration /Compensation Committee',
          link: constants.AUDIT_COMMITTEE,
        },
        {
          id: 2,
          title: 'Stakeholders Relationship Committee',
          link: constants.AUDIT_COMMITTEE,
        },
        {
          id: 3,
          title: 'Corporate Social Responsibility Committee',
          link: constants.AUDIT_COMMITTEE,
        },
        {
          id: 4,
          title: 'Risk Management Committee',
          link: constants.AUDIT_COMMITTEE,
        },
      ],
    },
    {
      dsId: 3,
      dsTitle: '(D) Code of Conduct for Board of Directors and Senior Management Personnel',
      dsDataSlug: [
        {
          id: 0,
          title: 'Code of Conduct for Board of Directors and Senior Management Personnel',
          link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/disclosures-regulation/code-of-conduct-for-board-members-and-senior-management.pdf',
        },
      ],
    },
    {
      dsId: 4,
      dsTitle: '(E) Vigil Mechanism/ Whistle Blower Policy',
      dsDataSlug: [
        {
          id: 0,
          title: 'Vigil Mechanism / Whistle Blower Policy',
          link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/disclosures-regulation/vigil-mechanism-whistle-blower-policy.pdf',
        },
      ],
    },
    {
      dsId: 5,
      dsTitle: '(F) Criteria of making payments to Non-executive Directors',
      dsDataSlug: [
        {
          id: 0,
          title: 'Criteria of making payments to Non-executive Directors ',
          link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/disclosures-regulation/nomination-and-remuneration-policy.pdf',
        },
      ],
    },
    {
      dsId: 6,
      dsTitle: '(G) Policy on dealing with Related Party Transactions',
      dsDataSlug: [
        {
          id: 0,
          title: 'Policy on dealing with Related Party Transactions',
          link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/disclosures-regulation/policy-on-materiality-of-and-dealing-with-related-party-transactions.pdf',
        },
      ],
    },
    {
      dsId: 7,
      dsTitle: '(H) Policy for determining material Subsidiaries',
      dsDataSlug: [
        {
          id: 0,
          title: 'Policy for determining material Subsidiaries',
          link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/disclosures-regulation/policy-for-determining-material-subsidiaries.pdf',
        },
      ],
    },
    {
      dsId: 8,
      dsTitle: '(I) Familiarization Programmes imparted to Independent Directors',
      dsDataSlug: [
        {
          id: 0,
          title: 'Familiarization Programmes imparted to Independent Directors',
          link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/disclosures-regulation/familiarization-programmes-imparted-to-independent-directors.pdf',
        },
      ],
    },
    {
      dsId: 9,
      dsTitle: '(J) Grievance Redressal details',
      dsDataSlug: [
        {
          id: 0,
          title: 'Grievance Redressal details',
          link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/disclosures-regulation/grievance-redressal-details.pdf',
        },
      ],
    },
    {
      dsId: 10,
      dsTitle: '(K) Contact Officials for handling Investor Grievances',
      dsDataSlug: [
        {
          id: 0,
          title: 'Contact Officials for handling Investor Grievances',
          link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/disclosures-regulation/contact-officials-for-handling-investor-grievances.pdf',
        },
      ],
    },
    {
      dsId: 11,
      dsTitle: '(L) Financial Information',
      dsDataSlug: [
        {
          id: 0,
          title: 'Notice of Board Meetings',
          link: '/',
        },
        {
          id: 1,
          title: 'Financial Results',
          link: '/',
        },
        {
          id: 2,
          title: 'Annual Reports',
          link: constants.ANNUAL_REPORTS_IPO,
        },
        {
          id: 3,
          title: 'Earnings News Release',
          link: '/',
        },
      ],
    },
    {
      dsId: 12,
      dsTitle: '(M) Shareholding Pattern',
      dsDataSlug: [
        {
          id: 0,
          title: 'Shareholding Pattern - 20.09.2023',
          link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/shareholder-information/shareholding-pattern/shareholding-pattern-20th-sep-2023.pdf',
        },
        {
          id: 0,
          title: 'Shareholding Pattern - 30.09.2023 ',
          link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/shareholder-information/shareholding-pattern/shareholding-pattern-30th-sep-2023.pdf',
        },
      ],
    },
    {
      dsId: 13,
      dsTitle: '(N) Agreements with the Media Companies',
      dsDataSlug: [
        {
          id: 0,
          title: 'NIL',
          link: '/',
        },
      ],
    },
    {
      dsId: 14,
      dsTitle: '(O) Schedule of Analysts or Institutional Investors meet and Presentations made to them',
      dsDataSlug: [
        {
          id: 0,
          title: 'Schedule of Meeting',
          link: '/',
        },
        {
          id: 1,
          title: 'Presentations',
          link: '/',
        },
        {
          id: 2,
          title: 'Audio or video recordings',
          link: '/',
        },
        {
          id: 3,
          title: 'Transcripts of post earnings/quarterly calls',
          link: '/',
        },
      ],
    },
    {
      dsId: 15,
      dsTitle: '(P) Name Changes',
      dsDataSlug: [
        {
          id: 0,
          title: 'Pursuant to conversion, the name of the Company was changed from Zaggle Prepaid Ocean Services Private Limited to Zaggle Prepaid Ocean Services Limited w.e.f. September 13, 2022.',
          link: '/',
        },
      ],
    },
    {
      dsId: 16,
      dsTitle: '(Q) Information Published in the Newspapers',
      dsDataSlug: [
        {
          id: 0,
          title: 'Financial Results Published in Newspapers',
          link: constants.FINANCIAL_RESULTS_PUBLISHED_NEWSPAPER,
        },
        {
          id: 1,
          title: 'General Meetings ',
          link: constants.DISCLOSURES_REGULATION_GENERAL_MEETINGS,
        },
        {
          id: 2,
          title: 'IEPF',
          link: '/',
        },
      ],
    },
    {
      dsId: 17,
      dsTitle: '(R) Credit Ratings',
      dsDataSlug: [
        {
          id: 0,
          title: 'Credit Rating',
          link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/disclosures-regulation/credit-rating-dated-november-03-2022.pdf',
        },
      ],
    },
    {
      dsId: 18,
      dsTitle: '(S) Financial Statements of Subsidiary Companies',
      dsDataSlug: [
        {
          id: 0,
          title: 'Financials Subsidiaries',
          link: '/',
        },
      ],
    },
    {
      dsId: 19,
      dsTitle: '(T) Secretarial Compliance Reports',
      dsDataSlug: [
        {
          id: 0,
          title: 'Secretarial Compliance Reports',
          link: '/',
        },
      ],
    },
    {
      dsId: 20,
      dsTitle: '(U) Policy for determination of materiality of events / information',
      dsDataSlug: [
        {
          id: 0,
          title: 'Policy for determination of materiality of events / information ',
          link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/disclosures-regulation/policy-for-determining-materiality-of-an-event-or-information.pdf',
        },
      ],
    },
    {
      dsId: 21,
      dsTitle: '(V) Contact details of Key Managerial Personnel',
      dsDataSlug: [
        {
          id: 0,
          title: 'Contact Details of KMPs',
          link: '/',
        },
      ],
    },
    {
      dsId: 22,
      dsTitle: '(W) Disclosure of other events or information',
      dsDataSlug: [
        {
          id: 0,
          title: 'Disclosure of events or information',
          link: constants.DISCLOSURE_EVENTS_INFORMATION,
        },
      ],
    },
    {
      dsId: 23,
      dsTitle: '(X) Statements of Deviations or Variations',
      dsDataSlug: [
        {
          id: 0,
          title: 'Statement on Deviation or Variation of funds Q2 FY 2023-24',
          link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/disclosures-regulation/statement-on-deviation-or-variation-of-funds-Q2-FY-2023-24.pdf',
        },
      ],
    },
    {
      dsId: 24,
      dsTitle: '(Y) Dividend Distribution Policy',
      dsDataSlug: [
        {
          id: 0,
          title: 'Dividend Distribution Policy',
          link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/disclosures-regulation/dividend-distribution-policy.pdf',
        },
      ],
    },
    {
      dsId: 25,
      dsTitle: '(Z) Annual Returns',
      dsDataSlug: [
        {
          id: 0,
          title: 'Annual Return - 21-22',
          link: PDF_IMPORTS.ANNUAL_RETURN_FY_21_22,
        },
        {
          id: 1,
          title: 'Annual Return - 22-23',
          link: PDF_IMPORTS.ANNUAL_RETURN_FY_22_23,
        },
        {
          id: 2,
          title: 'Part F of SEBI Disclosure',
          link: PDF_IMPORTS.PART_F_OF_SEBI_DISCLOSURE,
        },
        {
          id: 3,
          title: 'Part F Schedule-I - 2022-23',
          link: PDF_IMPORTS.PART_F_SCHEDULE_I,
        },
      ],
    },
  ],
});


export {
  COLLAPSE_MCMD,
};



// WEBPACK FOOTER //
// client/containers/StaticPages/DisclosuresRegulation/constants.js